// External imports
import React, { useState } from 'react';
import { Radio, FormControlLabel, RadioGroup, withStyles, Typography } from '@material-ui/core';
// Internal imports
import WebHelpers from '~/app/webHelpers.js';
// Redux Import
import { useSelector } from 'react-redux';
// Styling imports
import { styles } from '~/app/Components/Auth/css/switchOfficeYear.js';

/**
 * Handles displaying Office Radio List jsx
 *
 * @Component OfficeRadioList
 */
const OfficeRadioList = props => {
  const { classes } = props;
  const payload = WebHelpers.getJWTPayload();
  const { currentOfficeID } = useSelector(state => ({
    currentOfficeID: state.app.loggedInBasicInfo.office_id,
  }));

  const [officeID, setOfficeID] = useState(currentOfficeID);

  /**
   * Handles office selection change
   *
   * @param {Object} e eventDOM use to get the value of an input
   */
  const handleChange = e => {
    setOfficeID(e.target.value);
    props.onOfficeChange(e.target.value);
  };

  /**
   * Handles creating label for specific radio button
   *
   * @param {Object} office info used to create label
   * @returns {string} label for radio button
   */
  const getOfficeLabel = office => {
    return (
      <>
        <div>
          <Typography inline variant="subtitle2">
            {'Office Name: '}
          </Typography>
          {office.company_name}
        </div>
        <div>
          <Typography inline variant="subtitle2">
            {'EFIN: '}
          </Typography>
          {office.efin}
        </div>
        <div>
          <Typography inline variant="subtitle2">
            {'Address: '}
          </Typography>
          {office.office_address ? office.office_address : '(No Address on file)'}
        </div>
      </>
    );
  };

  /** Handles creating  radio button for each office */
  const getRadioButtons = () =>
    payload.offices.map((office, i) => {
      return (
        <FormControlLabel
          key={`${i}-${office.office_id}`}
          value={office.office_id}
          onChange={handleChange}
          control={<Radio checked={office.office_id === parseInt(officeID)} />}
          className={classes.label}
          label={getOfficeLabel(office)}
        />
      );
    });

  /** Handles setting Active or Inactive office depending on the active office */
  const getStatusLabels = () =>
    payload.offices.map(office => {
      const isActiveOffice = office.office_id === currentOfficeID;
      if (isActiveOffice) {
        return (
          <label
            key={`label-${office.office_id}`}
            className={`${isActiveOffice && classes.activeOffice} ${classes.smallLabels}`}
          >
            Active Account
          </label>
        );
      }
      return null;
    });

  const statusLabels = getStatusLabels();

  return (
    <RadioGroup value={officeID}>
      {getRadioButtons().map((rb, idx) => {
        return [rb, statusLabels[idx]];
      })}
    </RadioGroup>
  );
};

export default withStyles(styles)(OfficeRadioList);
